import store from './store/store';
import router from './router/router';

/* eslint-disable global-require */
const auth = {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  refreshData: {
    url: 'token/refresh', method: 'GET', enabled: true, interval: 30,
  },
  token: [
    {
      request: 'Authorization',
      response: 'Authorization',
      authType: 'bearer',
      foundIn: 'header',
    },
    {
      request: 'token',
      response: 'token',
      authType: 'bearer',
      foundIn: 'response',
    },
  ],
  loginData: {
    url: '/auth', method: 'POST', redirect: false, fetchUser: false,
  },
  tokenName: 'token',
  // authRedirect: { path: '/' },
  parseUserData(data) {
    const user = { ...data.data.user };

    store.dispatch('user/setLanguage', user.language);
    store.dispatch('user/setUserObject', user);

    if (!user.is_employee) {
      store.dispatch('company/fetchInitial', user.companies);
    }

    if (user.is_employee) {
      store.dispatch('employee/fetchApplications');
      store.dispatch('user/fetchFavorites');
      // store.dispatch('user/fetchNotifications'); TODO
    }

    store.dispatch('user/showNavigationDrawer');
    return user;
  },
};
/* eslint-enable global-require */
export default auth;
